export default __webpack_public_path__ + "static/media/main_nav_arrow_green.dd401894.svg";